/**
 * Get global messages element.
 * @return {Element}
 */
const getGlobalMessageElement = () => {
  return window.document.querySelector('#globalMessages');
};

/**
 * Supresses global error messages rendered via globalMessages.tag.
 */
const suppressGlobalErrorMessages = () => {
  const el = getGlobalMessageElement();
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
};

export {suppressGlobalErrorMessages};
